// extracted by mini-css-extract-plugin
export default {"selectusage":"SelectUsage_selectusage__KvkRO","selectusage-title":"SelectUsage_selectusage-title__qZVx1","selectusage-contents":"SelectUsage_selectusage-contents__hdblA"};